// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { Grid } from '@mui/material';
import { withStyles } from "tss-react/mui";
import cx from 'classnames';

export interface FieldProps {
  classes?: any; // to supress linting warning.
  className?: string;
  label: React.ReactNode;
  component?: React.ReactNode;
  disabled?: boolean;
}

const Field: React.FC<FieldProps> = (props: FieldProps) => {
  const { label, component, disabled } = props;
  const classes = withStyles.getClasses(props);

  return (
    <Grid
      container
      className={classes.root}
      justifyContent="space-between"
      alignItems="center"
    >
      <span className={classes.label}>{label}</span>
      {component && (
        <div className={cx(classes.component, { [classes.componentDisabled]: disabled })}>
          {component}
        </div>
      )}
    </Grid>
  );
};

const FieldStyled = withStyles(
  Field, 
  (theme, props) => ({
    "root": {
      marginTop: theme.spacing(5),
      alignItems: 'center'
    },
    "label": {
      fontSize: 15,
      // width: '30%',
      color: theme.palette.colors.greyDark,
      marginBottom: -1
    },
    "component": {
      fontSize: 16,
      flexGrow: 1,
      // maxWidth: '65%'
    },
    "componentDisabled": {
      opacity: .9,
      pointerEvents: 'none',
    }
  })
);

export default FieldStyled;